module.exports = __webpack_public_path__ + "static/media/speech-balloon_1f4ac.3ef55a27.png";